module.exports = __webpack_public_path__ + "static/media/medpad-slide9.79c986d6.png";